import { AlpineComponent } from "alpinejs";
import { updateSvg } from "jdenticon";
import { epochToDate } from "./utils";

export default (): AlpineComponent<any> => ({
  items: [],
  scores: {},
  next: null,
  apiKey: localStorage.getItem("apiKey") || "",
  apiKeyEntered: (localStorage.getItem("apiKey")?.length ?? 0) > 0,

  epochToDate: epochToDate,

  formatDate(date: Date) {
    const pad = (num: number) => String(num).padStart(2, "0");

    const yyyy = String(date.getFullYear());
    const MM = pad(date.getMonth() + 1); // Months are 0-based
    const dd = pad(date.getDate());
    const hh = pad(date.getHours());
    const mm = pad(date.getMinutes());
    const ss = pad(date.getSeconds());

    return `${yyyy}-${MM}-${dd} ${hh}:${mm}:${ss}`;
  },
  refreshJdenticons() {
    console.log("pre updating jdenticons");
    this.$nextTick(() => {
      document.querySelectorAll("svg[data-jdenticon-value]").forEach((svg) => {
        updateSvg(svg);
      });
    });
    console.log("updating jdenticons");
  },
  async scoreSightings() {
    let byDuck = await processSightings((acc, sighting) => {
      acc[sighting.duck_id] ||= [];
      acc[sighting.duck_id].push(sighting);
      acc[sighting.duck_id].sort((a, b) => a.timestamp.getTime() - b.timestamp.getTime());
      return acc;
    }, {} as Record<string, Sighting[]>);

    // console.log(byDuck);

    this.scores = Object.values(byDuck).reduce((acc, events) => {
      const alreadyScored: Record<string, boolean> = {};
      events.forEach((sighting, index) => {
        if (!alreadyScored[sighting.user_id]) {
          alreadyScored[sighting.user_id] = true;

          const points = index === 0 ? 10 : 5; // 10 points for first, 5 for others
          acc[sighting.user_id] ||= {
            nicks: new Set(),
            ducks: new Set(),
            points: 0,
            firsts: 0,
          };
          acc[sighting.user_id].nicks.add(sighting.nickname);
          acc[sighting.user_id].ducks.add(sighting.duck_id);
          acc[sighting.user_id].firsts += index ? 0 : 1;
          acc[sighting.user_id].points += points;
        }
      });
      return acc;
    }, {} as Record<string, Score>);

    this.$nextTick(() => this.refreshJdenticons());
    // console.log(this.scores);
  },
  saveApiKey() {
    if (this.apiKey.trim()) {
      localStorage.setItem("apiKey", this.apiKey.trim());
      this.apiKeyEntered = true;
    }
  },
  loadText() {
    return this.next ? "Load next page" : "Load first page";
  },
  loadData() {
    fetch(
      "https://boa3linyvchh4rama44dldpcne0zssvf.lambda-url.eu-north-1.on.aws/",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Quack-Auth": this.apiKey,
        },
        body: JSON.stringify({ next: this.next }),
      }
    )
      .then((response) => response.json())
      .then((data) => {
        this.next = data.next;
        this.items = data.sightings;
      })
      .then(() => this.refreshJdenticons())
      .catch((error) => alert("Error sending request." + error));
  },
});

type Score = {
  nicks: Set<string>;
  ducks: Set<string>;
  points: number;
  firsts: number;
};

type ApiError = { message: string };
type FetchedSightings = {
  next?: string;
  sightings: Sighting[];
};

type Sighting = {
  duck_id: string;
  timestamp: Date;
  user_id: string;
  nickname: string;
};

async function fetchSightings(next?: string) {
  return fetch(
    "https://boa3linyvchh4rama44dldpcne0zssvf.lambda-url.eu-north-1.on.aws/",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ next }),
    }
  )
    .then((response) => response.json())
    .then((data) => data as FetchedSightings | ApiError);
}

async function* getAllSightings() {
  let next = undefined; // Initial "next" param is empty
  while (true) {
    const data = await fetchSightings(next);
    if ("message" in data) {
      console.error(data.message);
      return;
    }
    const { next: newNext, sightings } = data;
    for (const sighting of sightings) {
      sighting.timestamp = epochToDate(sighting.timestamp as unknown as number);
      yield sighting as Sighting; // Yield each item one by one
    }
    if (!newNext) break; // Stop when "next" is empty
    next = newNext;
  }
}

// Reduce-like function that processes sightings as they arrive
async function processSightings<T>(
  reducer: (acc: T, s: Sighting) => T,
  initialValue: T
) {
  let accumulator = initialValue;
  for await (const sighting of getAllSightings()) {
    accumulator = reducer(accumulator, sighting);
  }
  return accumulator;
}

